{
    "UnreturnedCallsFilterSectionTitle": "Filtrage des appels non retournés",
    "UnreturnedCallsFilterSectionDesc": "Vous pouvez également contrôler les types d'appels entrants inclus dans les rapports « Appels perdus sans retour ».",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Inclure Escaped To Calls :",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Inclure les appels redirigés\/débordés :",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Inclure les appels transférés :",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Inclure tous les autres appels :",
    "NAME": "UnreturnedCallsFilter"
}